import { render, staticRenderFns } from "./WaGroupUpload.vue?vue&type=template&id=1c3a901b&scoped=true"
import script from "./WaGroupUpload.vue?vue&type=script&lang=js"
export * from "./WaGroupUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a901b",
  null
  
)

export default component.exports